import { render, staticRenderFns } from "./CatalogueSingle.vue?vue&type=template&id=a94c38dc&scoped=true&lang=pug&"
import script from "./CatalogueSingle.vue?vue&type=script&lang=js&"
export * from "./CatalogueSingle.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueSingle.vue?vue&type=style&index=0&id=a94c38dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94c38dc",
  null
  
)

export default component.exports